var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZsfwjg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 69",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "98.993048%",
    id: "q65t1kp1gc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB6F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227BF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "o4mobs1w5b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DCFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A2FE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44%",
    y: "-37%",
    width: "187.9%",
    height: "173.9%",
    filterUnits: "objectBoundingBox",
    id: "d3dxuyw9ua"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d3dxuyw9ua)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6803617,5.32126465 C35.0309923,5.32126465 40.7801506,7.91040057 44.9418209,12.0956739 C49.1055324,16.2829999 51.6803617,22.0678691 51.6803617,28.457381 C51.6803617,33.9829141 48.2586505,40.7625463 44.0278908,46.7321277 C38.4646199,54.5818759 31.4099872,61.3212646 28.6803617,61.3212646 C25.9507362,61.3212646 18.8961034,54.5818759 13.3328325,46.7321277 C9.10207284,40.7625463 5.68036165,33.9829141 5.68036165,28.457381 C5.68036165,22.0678691 8.25519091,16.2829999 12.4189024,12.0956739 C16.5805727,7.91040057 22.329731,5.32126465 28.6803617,5.32126465 Z",
    stroke: "url(#o4mobs1w5b)",
    strokeWidth: 2,
    fill: "url(#q65t1kp1gc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8728052,21.8969051 L34.8728052,37.3338281 C34.8728052,37.431982 34.9559873,37.5122897 35.0576543,37.5122897 L36.0743241,37.5122897 C36.1764134,37.5122897 36.2591732,37.4323897 36.2591732,37.3338281 L36.2591732,24.3061358 C36.2591732,24.207982 36.3423553,24.1276743 36.4440223,24.1276743 L38.1076638,24.1276743 C39.128557,24.1276743 39.9561544,24.9266738 39.9561544,25.9122897 L39.9561544,37.3338281 C39.9561544,37.431982 40.0393365,37.5122897 40.1410035,37.5122897 L40.6955507,37.5122897 C40.7972177,37.5122897 40.8803997,37.5925974 40.8803997,37.6907512 L40.8803997,39.1184435 C40.8803997,39.2170051 40.79764,39.2969051 40.6955507,39.2969051 L18.8833614,39.2969051 C18.7812721,39.2969051 18.6985123,39.2170051 18.6985123,39.1184435 L18.6985123,37.6907512 C18.6985123,37.5925973 18.7816944,37.5122896 18.8833614,37.5122897 L19.9000312,37.5122897 C20.0021205,37.5122897 20.0848803,37.4323897 20.0848803,37.3338281 L20.0848803,21.8969051 C20.0848803,20.4184813 21.3262764,19.219982 22.8576162,19.219982 L32.1000693,19.219982 C33.6314091,19.219982 34.8728052,20.4184813 34.8728052,21.8969051 Z M29.6627024,28.1430589 L25.4798322,28.1430589 C25.4098281,28.1430589 25.3530785,28.2762255 25.3530785,28.4404948 L25.3530785,30.0763922 C25.3530785,30.239982 25.4101177,30.3738281 25.4798322,30.3738281 L29.6627024,30.3738281 C29.7327065,30.3738281 29.789456,30.2406615 29.789456,30.0763922 L29.789456,28.4404948 C29.789456,28.2762255 29.7327065,28.1430589 29.6627024,28.1430589 L29.6627024,28.1430589 Z M31.8301897,23.6815204 L23.3123449,23.6815204 C23.2143391,23.6815204 23.1348898,23.814687 23.1348898,23.9789563 L23.1348898,25.6148538 C23.1348898,25.7784435 23.2147446,25.9122897 23.3123449,25.9122897 L31.8301897,25.9122897 C31.9281954,25.9122897 32.0076448,25.7791231 32.0076448,25.6148538 L32.0076448,23.9789563 C32.0076448,23.814687 31.9281954,23.6815204 31.8301897,23.6815204 L31.8301897,23.6815204 Z",
    fill: "#E2F2FF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZsfwjg);
export default __webpack_public_path__ + "static/media/zsfwjg.9077b1ba0e03a439e3f5178c27447333.svg";
export { ForwardRef as ReactComponent };